module.exports = __webpack_public_path__ + "img/01.b1d50a15.png";